import React from "react"
import styles from './Schema.module.css'

export const Schema = (props) => {
    return <span className={styles.container} >
        {props.schema.split(' ').map(slice => {
            if (slice.includes('_Alt')) {
                return <span
                    className={styles.alt}
                    key={slice}
                    >{slice}</span>
            }
            return <span
                className={styles.default}
                key={slice}
                >{slice}</span>
        })}
    </span>
}